import { ArrowsRightLeftIcon } from '@heroicons/react/24/solid';
import { ProductType } from '../../../hooks/useProducts';
import { Gwei } from '../../../lib/gwei';
import { getDecimalPlaces } from '../../../lib/math';
import { usdToggleTooltip } from '../../../lib/tooltips';
import { Button } from '../../catalyst-ui-kit/button';
import { Input } from '../../Input/Input';
import { Tooltip } from '../../Tooltip/Tooltip';
import { useTradeFormStore } from './TradeFormState';

const labelId = 'trade-form-amount-input';
const errorId = 'trade-form-amount-error';

type TradeFormAmountInputProps = {
  product: ProductType;
  amountErrorMessage: string | undefined;
};

export const TradeFormAmountInput: React.FC<TradeFormAmountInputProps> = ({
  product,
  amountErrorMessage,
}) => {
  const amount = useTradeFormStore((s) => s.amount);
  const setAmount = useTradeFormStore((s) => s.setAmount);
  const setActiveInput = useTradeFormStore((s) => s.setActiveInput);
  const decimals = getDecimalPlaces(product.lotSize);

  return (
    <Input
      label="Size"
      aria-label="Size"
      inputType="number"
      aria-describedby={labelId}
      aria-errormessage={amountErrorMessage ? errorId : undefined}
      aria-required="true"
      decimalScale={decimals}
      step={Gwei.fmt(product.lotSize)}
      min={0}
      inputMode="numeric"
      value={amount !== undefined ? Gwei.fmt(amount) : ''}
      rightElement={
        <>
          <span className="text-xs font-medium text-contentSecondary">{product.baseTokenName}</span>
          <Tooltip content={usdToggleTooltip()}>
            <Button
              text
              color="secondary"
              aria-label="Toggle Input"
              onClick={() => setActiveInput('total')}
              className="ml-2"
            >
              <ArrowsRightLeftIcon />
            </Button>
          </Tooltip>
        </>
      }
      containerClassName={amountErrorMessage ? 'border border-borderError' : ''}
      hasError={Boolean(amountErrorMessage)}
      onValueChange={(values, sourceInfo) => {
        if (sourceInfo.source !== 'event') return;
        if (values.value === '') {
          setAmount(undefined);
          return;
        }
        setAmount(Gwei.toGwei(values.value));
      }}
    />
  );
};
